<div class="pdf-shell">
    <!-- Kept alive so pdf.js loads its scripts once; loading, empty and error states are overlays -->
    <div class="pdf-viewer-container">
        <div class="pdf-viewer-frame">
            <ngx-extended-pdf-viewer
                [src]="resolvedSrc"
                (pdfLoaded)="onPdfLoaded()"
                (pdfLoadingFailed)="onPdfLoadingFailed()"
                [(page)]="page"
                [(zoom)]="zoom"
                [showSecondaryToolbarButton]="false"
                [showOpenFileButton]="false"
                [showSidebarButton]="false"
                [sidebarVisible]="false"
                [showPrintButton]="false"
                [showDownloadButton]="'always-visible'"
                [showRotateCwButton]="false"
                [showRotateCcwButton]="false"
                [showHighlightEditor]="false"
                [filenameForDownload]="documentName">
            </ngx-extended-pdf-viewer>
        </div>

        @if (loading || viewerLoading) {
            <div class="pdf-overlay">
                <cb-loading-spinner></cb-loading-spinner>
            </div>
        } @else if (!resolvedSrc) {
            <div class="pdf-overlay pdf-empty">
                <div class="pdf-empty-card">
                    <div class="cb-dark-grey pdf-empty-title">{{ emptyMessage }}</div>
                    <div class="cb-grey">{{ emptyDescription }}</div>
                    @if (showRetry) {
                        <button mat-stroked-button class="pdf-empty-retry" (click)="retry.emit()">
                            <mat-icon>refresh</mat-icon>
                            Try again
                        </button>
                    }
                </div>
            </div>
        }
    </div>

    @if (showSlowLoadingMessage) {
        <div class="pdf-slow-loading">
            <mat-icon>hourglass_empty</mat-icon>
            <span>This document is taking longer than usual to load. It may be a large file, please wait.</span>
        </div>
    }
</div>
